import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import App from './App';
import Dashboard from './Dashboard';
import Users from "./Users";
import KeyForm from "./Keyform";
import User from "./User";

const Main: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" Component={Dashboard} />
        <Route path="/app" Component={App} />
        <Route path="/users" Component={Users} />
        <Route path="/keyform" Component={KeyForm} />
        <Route path="/user/:sslSerialNumber" Component={User} />
      </Routes>
    </Router>
  );
};

ReactDOM.render(<Main />, document.getElementById('root'));
